import classNames from 'classnames';
import React from 'react';
import ClientTitle from './comps/client-title';
import ItemLinkA from './comps/ItemLinkA';
import './index.scss';

interface EfFooterNavV2Sub1ItemProps {
    /**
     * 文章链接
     */
    url?: string;
    /**
     * heading
     */
    heading?: string;
}

interface EfhFooterNavV2Sub1ItemProps {
    /**
     * title
     */
    name?: React.ReactNode;
    /**
     * 子内容列表
     */
    subs?: EfFooterNavV2Sub1ItemProps[];
}

export interface EfhFooterNavV2Props {
    /**
     * 主题色
     */
    theme?: 'white' | 'black' | 'gray';
    /**
     * 列表
     */
    items: EfhFooterNavV2Sub1ItemProps[];
    /**
     * 样式名
     */
    className?: string;
}

/**
 *
 * 底部导航-v1
 */
const EfhFooterNavV2: React.FC<EfhFooterNavV2Props> = ({ theme, items = [], className }) => {
    const prefixCls = `ef-footer-nav-v2`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
    });

    return (
        <nav className={classes}>
            {items.map((itemA: EfhFooterNavV2Sub1ItemProps, index1: number) => {
                const listA = itemA.subs || [];
                return (
                    <div key={index1} className={`${prefixCls}-column`}>
                        <ClientTitle prefixCls={prefixCls} title={itemA.name} />
                        <ul className={`${prefixCls}-sub-list`}>
                            {listA.map((itemC1: EfFooterNavV2Sub1ItemProps, index2: number) => {
                                return (
                                    <li key={index2} className={`${prefixCls}-sub-item`}>
                                        <ItemLinkA prefixCls={prefixCls} itemC1={itemC1} index1={index1} index2={index2} itemA={itemA} />
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                );
            })}
        </nav>
    );
};

export default EfhFooterNavV2;
